var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultBrandingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 24,
    viewBox: "0 0 97 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64702 2.82351C7.20337 2.82351 8.47054 4.09067 8.47054 5.64702C8.47054 7.20337 7.20337 8.47053 5.64702 8.47053C4.09067 8.47053 2.82351 7.20337 2.82351 5.64702C2.82351 4.08947 4.09067 2.82351 5.64702 2.82351ZM5.64702 0C2.52832 0 0 2.52832 0 5.64702C0 8.76572 2.52832 11.294 5.64702 11.294C8.76573 11.294 11.294 8.76572 11.294 5.64702C11.294 2.52832 8.76573 0 5.64702 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.294 12.7051H0V15.5286H11.294V12.7051Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.294 21.1758H0V23.9993H11.294V21.1758Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.294 16.9414H0V19.7649H11.294V16.9414Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9858 0H39.5771V23.5121H43.9858V0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3072 6.3658C20.6069 6.3658 19.0193 6.84818 17.6729 7.68216V0H13.2643V23.5121H17.6729V22.6829C19.0193 23.5169 20.6069 23.9992 22.3072 23.9992C27.1766 23.9992 31.1245 20.0514 31.1245 15.1819C31.1245 10.3125 27.1766 6.3658 22.3072 6.3658ZM22.3072 19.5906C19.8761 19.5906 17.8985 17.6131 17.8985 15.1819C17.8985 12.7508 19.8761 10.7733 22.3072 10.7733C24.7383 10.7733 26.7159 12.7508 26.7159 15.1819C26.7159 17.6131 24.7383 19.5906 22.3072 19.5906Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5683 10.7739C89.9994 10.7739 91.9769 12.7514 91.9769 15.1826C91.9769 17.6137 89.9994 19.5912 87.5683 19.5912C85.1372 19.5912 83.1596 17.6137 83.1596 15.1826C83.1596 12.7514 85.1372 10.7739 87.5683 10.7739ZM87.5683 6.36523C82.6988 6.36523 78.7509 10.3131 78.7509 15.1826C78.7509 20.052 82.6988 23.9999 87.5683 23.9999C92.4377 23.9999 96.3856 20.052 96.3856 15.1826C96.3856 10.3119 92.4377 6.36523 87.5683 6.36523Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5551 6.37305H33.1465V23.5109H37.5551V6.37305Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3508 4.40866C36.5682 4.40866 37.5551 3.42175 37.5551 2.20433C37.5551 0.986912 36.5682 0 35.3508 0C34.1334 0 33.1465 0.986912 33.1465 2.20433C33.1465 3.42175 34.1334 4.40866 35.3508 4.40866Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4814 6.3658C59.781 6.3658 58.1935 6.84818 56.8471 7.68216V0H52.4385V23.5121H56.8471V22.6829C58.1935 23.5169 59.781 23.9992 61.4814 23.9992C66.3508 23.9992 70.2987 20.0514 70.2987 15.1819C70.2987 10.3125 66.3508 6.3658 61.4814 6.3658ZM61.4814 19.5906C59.0503 19.5906 57.0727 17.6131 57.0727 15.1819C57.0727 12.7508 59.0503 10.7733 61.4814 10.7733C63.9125 10.7733 65.89 12.7508 65.89 15.1819C65.89 17.6131 63.9125 19.5906 61.4814 19.5906Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.729 6.37305H72.3204V23.5109H76.729V6.37305Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5248 4.40866C75.7422 4.40866 76.7291 3.42175 76.7291 2.20433C76.7291 0.986912 75.7422 0 74.5248 0C73.3073 0 72.3204 0.986912 72.3204 2.20433C72.3204 3.42175 73.3073 4.40866 74.5248 4.40866Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.212 23.9985C49.4294 23.9985 50.4164 23.0116 50.4164 21.7942C50.4164 20.5768 49.4294 19.5898 48.212 19.5898C46.9946 19.5898 46.0077 20.5768 46.0077 21.7942C46.0077 23.0116 46.9946 23.9985 48.212 23.9985Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBrandingIcon);
export default __webpack_public_path__ + "static/media/defaultBrandingIcon.cfa788559d6ccd3762d3c98bfe600d5b.svg";
export { ForwardRef as ReactComponent };